import React, { useEffect } from "react";
import './_GenericDashboard.scss'
import "../_Progress.scss";
import missionBanner from '../../../assets/upgrade-images/mission-banner.svg'
import missionBannerDark from '../../../assets/upgrade-images/mission-banner_dark.svg'
import { useDispatch, useSelector } from 'react-redux'
import { FetchGameCompletedPercentages } from "../../../Services/UpgradeDashboardServices/UpgradeDashboardServices";
import { Loader } from "semantic-ui-react";
import ProgressSvg from '../../CommonComponent/progressSvg'

const GenericDashboard = ({ isHeaderManu }) => {
    const dispatch = useDispatch()
    const { profileReducer, gamesPercentageReducer, loader } = useSelector(state => state)
    const profileDetail = profileReducer?.profileDetail?.data?.user
    const userName = profileDetail?.first_name ? profileDetail?.first_name + " " + profileDetail?.last_name : ""
    let { cohort_progress, game_coverage } = gamesPercentageReducer
    let { isLoading } = loader

    useEffect(() => {
        fetchGamesProgressData()
        // eslint-disable-next-line 
    }, [])

    const fetchGamesProgressData = async () => {
        dispatch(FetchGameCompletedPercentages());
    }

    function calculateDays(dateString) {
        var currentDate = new Date()
        var inputDate = new Date(dateString)
        var timeDiff = inputDate.getTime() - currentDate.getTime()
        var days = Math.ceil(timeDiff / (1000 * 3600 * 24));
        return days;
    }

    const setProgressStyle = (val, number) => {
        let variable = `--bar-${number}-width`
        return { [variable]: `${val}%` }
    }

    return (
        <>
            <main
                className="talwind-dashboard max-w-xs mx-auto pt-24 pb-20 flex flex-col gap-6 w-full transition-all duration-300 sm:max-w-[420px] md:max-w-[calc(100vw-80px)] md:pl-16"
            >
                <div
                    id="main_section"
                    className={isHeaderManu ? "flex flex-col gap-6 transition-all duration-30 md:w-[100%] lg:w-[100%] xl:w-[100%] 2xl:w-[100%] 3xl:w-[100%] md:ml-auto" : "flex flex-col gap-6 transition-all duration-30 md:w-[72%] lg:w-[79%] xl:w-[84.5%] 2xl:w-[86.5%] 3xl:w-[90%] md:ml-auto"}
                >
                    <div
                        className="relative hero-head flex flex-col items-center gap-8 mt-10 p-4 md:p-12 lg:flex lg:flex-row lg:items-center bg-[#CCE0F080] rounded-2xl md:pl-8 lg:mt-16 dark:bg-[#B1B1B133] transition-all duration-300"
                    >
                        <div
                            className="w-full pl-4 lg:pl-0 md:w-[440px] lg:w-[400px] flex flex-col gap-6"
                        >
                            <h1
                                className="font-rubik font-medium text-lg md:text-xl dark:text-[#F5F5F5]"
                            >

                                <span className="font-rubik font-bold text-xl md:text-2xl"> Hello  {userName}</span>

                            </h1>
                            <h2 className="dark:text-[#F5F5F5]"> Welcome!</h2>
                        </div>
                        <div
                            className="lg:absolute right-[0%] -top-[30%] xl:right-[15%] 2xl:right-[18%] 3xl:right-[23%]"
                        >
                            <img
                                className="transition-all duration-300 dark:hidden"
                                src={missionBanner}
                                alt=""
                            />
                            <img
                                className="transition-all duration-300 hidden dark:block"
                                src={missionBannerDark}
                                alt=""
                            />
                        </div>
                    </div>

                    <div className="hero grid grid-cols-1 gap-6 xl:grid-cols-3">
                        {/* first */}
                        <div
                            className="card-1 flex flex-col gap-6 w-full bg-[#FFFFFF] p-6 rounded-2xl dark:bg-[#212121] transition-all duration-300"
                        >
                            <div
                                className="card-head border-b border-[#202A31] border-opacity-30 pb-3 dark:border-[#CED8DF4D]"
                            >
                                <h2
                                    className="font-rubik font-medium text-xl text-[#1A1919] dark:text-[#F5F5F5]"
                                >
                                    Your Progress
                                </h2>
                            </div>
                            <div className="card-body flex flex-col gap-6">
                                {
                                    isLoading ? <div className="margin-top-loader" >
                                        <Loader size='big' active inline='centered' />
                                    </div>
                                        : game_coverage ?
                                            <>
                                                {
                                                    Object.keys(game_coverage)?.map((game, index) => {
                                                        let value = game_coverage[game]
                                                        let label = game.includes('game') ? game.slice(0, -1) + ' ' + (index + 1) : game
                                                        return (
                                                            <div key={game} className="border overflow-hidden rounded-lg justify-between py-1 px-6 shadow-[0px_8px_24px_rgba(69,69,80,0.1)] bg-[#FDFDFD] dark:bg-[#303030]">
                                                                <h2
                                                                    className="font-rubik font-medium text-base text-[#1A1919] dark:text-[#F5F5F5] capitalize"
                                                                >
                                                                    {/* Game {index + 1} */}
                                                                    {label}
                                                                </h2>
                                                                <div
                                                                    className="ba-block flex justify-between items-center gap-6"
                                                                >
                                                                    <div className="w-full h-2.5 overflow-hidden bg-[#e1ecf8] rounded-2xl border-dashed border-[Neutral/ 50] border-[0.497577px] dark:border-[#F5F5F54D]">
                                                                        <div
                                                                            className={value ? `h-2.5 bg-[#1B75BC] rounded-2xl animate-[bar${index + 1}_2s_linear] w-[${value}%]` : `h-2.5 bg-[#1B75BC] rounded-2xl w-[0%] `}
                                                                            style={setProgressStyle(value, index + 1)}
                                                                        ></div>
                                                                    </div>
                                                                    <div
                                                                        className="bar-value1 font-rubik text-base text-[#39434F] dark:text-[#B1B1B1] min-w-8 text-end"
                                                                    >
                                                                        {/* {value > 0 ? `${value + "%"}` : `${"0%"}`} */}
                                                                        {value.toFixed(2).toString().padStart(3, ' ')}%
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                                <div className="border overflow-hidden rounded-lg justify-between py-1 px-6 shadow-[0px_8px_24px_rgba(69,69,80,0.1)] bg-[#FDFDFD] dark:bg-[#303030]">
                                                    <h2
                                                        className="font-rubik font-medium text-base text-[#1A1919] dark:text-[#F5F5F5]"
                                                    >
                                                        SX<sup>2</sup> Survey
                                                    </h2>

                                                    <div
                                                        className="bar-block flex justify-between items-center gap-6"
                                                    >
                                                        <div
                                                            className="bar1 w-full h-2.5 overflow-hidden bg-[#e1ecf8] rounded-2xl border-dashed border-[Neutral/ 50] border-[0.497577px] transition-all duration-300 dark:border-[#F5F5F54D]"
                                                        >
                                                            <div
                                                                className="front-bar6 h-2.5 bg-[#1B75BC] rounded-2xl w-[10%]"
                                                            ></div>
                                                        </div>
                                                        <div
                                                            className="bar-value1 font-rubik text-base text-[#39434F] dark:text-[#B1B1B1] min-w-8 text-end"
                                                        >
                                                            10%
                                                        </div>
                                                    </div>
                                                </div>

                                            </>

                                            : <></>
                                }

                            </div>
                        </div>
                        {/* second */}
                        <div
                            className="card-2 flex flex-col gap-6 w-full bg-[#FFFFFF] p-6 rounded-2xl dark:bg-[#212121] transition-all duration-300"
                        >
                            <div
                                className="card-head border-b border-[#202A31] border-opacity-30 pb-3 dark:border-[#CED8DF4D]"
                            >
                                <h2
                                    className="font-rubik font-medium text-xl text-[#1A1919] dark:text-[#F5F5F5]"
                                >
                                    Your Cohort’s Progress
                                </h2>
                            </div>
                            <div className="card-body flex flex-col gap-4">
                                {
                                    isLoading ? <div className="margin-top-loader" >
                                        <Loader size='big' active inline='centered' />
                                    </div>
                                        : cohort_progress ?
                                            <>{Object.keys(cohort_progress)?.map((game, index) => {
                                                let value = cohort_progress[game]
                                                let label = game.includes('game') ? game.slice(0, -1) + ' ' + (index + 1) : game
                                                const animationDuration = 1000; // 1 second per percent
                                                return (
                                                    <div className="flex border rounded-lg overflow-hidden justify-between py-1 px-6 shadow-[0px_8px_24px_rgba(69,69,80,0.1)] bg-[#FDFDFD] dark:bg-[#303030]" key={index}>
                                                        <h2 className="font-rubik font-medium text-base text-[#1A1919] dark:text-[#F5F5F5] capitalize">
                                                            {/* Game {index + 1} */}
                                                            {label}
                                                        </h2>
                                                        <ProgressSvg
                                                            value={value}
                                                            animationDuration={1000}
                                                        />
                                                       
                                                    </div>
                                                )
                                            })
                                            }
                                                <div className="flex border overflow-hidden rounded-lg justify-between py-1 px-6 shadow-[0px_8px_24px_rgba(69,69,80,0.1)] bg-[#FDFDFD] dark:bg-[#303030]">
                                                    <h2
                                                        className="font-rubik font-medium text-base text-[#1A1919] dark:text-[#F5F5F5]"
                                                    >
                                                        SX<sup>2</sup> Survey
                                                    </h2>
                                                    <ProgressSvg
                                                        value={0.00}
                                                        animationDuration={1000}
                                                    />
                                                </div>
                                            </>
                                            : <></>
                                }

                            </div>
                        </div>

                        {/* third */}

                        <div
                            className="card-3 w-full bg-[#FFFFFF] p-6 rounded-2xl dark:bg-[#212121] transition-all duration-300 flex flex-col gap-6"
                        >
                            <div
                                className="card-head border-b border-[#202A31] border-opacity-30 pb-3 dark:border-[#CED8DF4D]"
                            >
                                <h2
                                    className="font-rubik font-medium text-xl text-[#1A1919] dark:text-[#F5F5F5]"
                                >
                                    Time Table
                                </h2>
                            </div>
                            <div className="card-body flex flex-col gap-4">
                                <div
                                    className="time-block relative flex rounded-l-sm overflow-hidden rounded-r-lg justify-between py-2 px-6 shadow-[0px_8px_24px_rgba(69,69,80,0.1)] bg-[#FDFDFD] dark:bg-[#303030] transition-all duration-300"
                                >
                                    <div
                                        className="w-1 h-16 bg-[#42E8E0] rounded-sm absolute top-0 left-0"
                                    ></div>
                                    <div>
                                        <p
                                            className="font-rubik text-sm text-[#656575] pb-0.5 dark:text-[#B1B1B1]"
                                        >
                                            Aug 20
                                        </p>
                                        <h3
                                            className="font-rubik font-semibold text-base text-[#1A1919] dark:text-[#F5F5F5]"
                                        >
                                            {/* Game 1 */}
                                            Slide
                                        </h3>
                                    </div>
                                    <div>
                                        <span
                                            className="text-[#656575] font-rubik bg-[#F8F7F1] rounded-sm text-xs py-1 px-2 dark:bg-[#121212] dark:text-[#B4B4B4] transition-all duration-300"
                                        >Due</span>
                                        <p><small className="text-[#00FF00]" >{calculateDays("2023-08-20")} days left</small></p>
                                    </div>
                                </div>

                                <div
                                    className="time-block relative flex rounded-l-sm overflow-hidden rounded-r-lg justify-between py-2 px-6 shadow-[0px_8px_24px_rgba(69,69,80,0.1)] bg-[#FDFDFD] dark:bg-[#303030] transition-all duration-300"
                                >
                                    <div
                                        className="w-1 h-16 bg-[#77C05C] rounded-sm absolute top-0 left-0"
                                    ></div>
                                    <div>
                                        <p
                                            className="font-rubik text-sm text-[#656575] pb-0.5 dark:text-[#B1B1B1]"
                                        >
                                            Aug 22
                                        </p>
                                        <h3
                                            className="font-rubik font-semibold text-base text-[#1A1919] dark:text-[#F5F5F5]"
                                        >
                                            {/* Game 2 */}
                                            Stack
                                        </h3>

                                    </div>
                                    <div>
                                        <span
                                            className="text-[#656575] font-rubik bg-[#F8F7F1] rounded-sm text-xs py-1 px-2 dark:bg-[#121212] dark:text-[#B4B4B4] transition-all duration-300"
                                        >Due</span>
                                        <p><small className="text-[#00FF00]">{calculateDays("2023-08-22")} days left</small> </p>
                                    </div>
                                </div>

                                <div
                                    className="time-block relative flex rounded-l-sm overflow-hidden rounded-r-lg justify-between py-2 px-6 shadow-[0px_8px_24px_rgba(69,69,80,0.1)] bg-[#FDFDFD] dark:bg-[#303030] transition-all duration-300"
                                >
                                    <div
                                        className="w-1 h-16 bg-[#FF8676] rounded-sm absolute top-0 left-0"
                                    ></div>
                                    <div>
                                        <p
                                            className="font-rubik text-sm text-[#656575] pb-0.5 dark:text-[#B1B1B1]"
                                        >
                                            Aug 24
                                        </p>
                                        <h3
                                            className="font-rubik font-semibold text-base text-[#1A1919] dark:text-[#F5F5F5]"
                                        >
                                            Match
                                        </h3>
                                    </div>
                                    <div>
                                        <span
                                            className="text-[#656575] font-rubik bg-[#F8F7F1] rounded-sm text-xs py-1 px-2 dark:bg-[#121212] dark:text-[#B4B4B4] transition-all duration-300"
                                        >Due</span >
                                        <p><small className="text-[#00FF00]">{calculateDays("2023-08-24")} days left</small> </p>
                                    </div>
                                </div>

                                {/* <div
                                    className="time-block relative flex rounded-l-sm overflow-hidden rounded-r-lg justify-between py-2 px-6 shadow-[0px_8px_24px_rgba(69,69,80,0.1)] bg-[#FDFDFD] dark:bg-[#303030] transition-all duration-300"
                                >
                                    <div
                                        className="w-1 h-16 bg-[#4136A4] rounded-sm absolute top-0 left-0"
                                    ></div>
                                    <div>
                                        <p
                                            className="font-rubik text-sm text-[#656575] pb-0.5 dark:text-[#B1B1B1]"
                                        >
                                            Aug 26
                                        </p>
                                        <h3
                                            className="font-rubik font-semibold text-base text-[#1A1919] dark:text-[#F5F5F5]"
                                        >
                                            Game 4
                                        </h3>
                                    </div>
                                    <div>
                                        <span
                                            className="text-[#656575] font-rubik bg-[#F8F7F1] rounded-sm text-xs py-1 px-2 dark:bg-[#121212] dark:text-[#B4B4B4] transition-all duration-300"
                                        >Due</span>
                                        <p><small className="text-[#00FF00]">{calculateDays("2023-08-26")} days left</small></p>
                                    </div>
                                </div>

                                <div
                                    className="time-block relative flex rounded-l-sm overflow-hidden rounded-r-lg justify-between py-2 px-6 shadow-[0px_8px_24px_rgba(69,69,80,0.1)] bg-[#FDFDFD] dark:bg-[#303030] transition-all duration-300"
                                >
                                    <div
                                        className="w-1 h-16 bg-[#4136A4] rounded-sm absolute top-0 left-0"
                                    ></div>
                                    <div>
                                        <p
                                            className="font-rubik text-sm text-[#656575] pb-0.5 dark:text-[#B1B1B1]"
                                        >
                                            Aug 26
                                        </p>
                                        <h3
                                            className="font-rubik font-semibold text-base text-[#1A1919] dark:text-[#F5F5F5]"
                                        >
                                            Game 5
                                        </h3>
                                    </div>
                                    <div>
                                        <span
                                            className="text-[#656575] font-rubik bg-[#F8F7F1] rounded-sm text-xs py-1 px-2 dark:bg-[#121212] dark:text-[#B4B4B4] transition-all duration-300"
                                        >Due</span>
                                        <p><small className="text-[#00FF00]">{calculateDays("2023-08-28")} days left</small></p>
                                    </div>
                                </div> */}

                                <div
                                    className="time-block relative flex rounded-l-sm overflow-hidden rounded-r-lg justify-between py-2 px-6 shadow-[0px_8px_24px_rgba(69,69,80,0.1)] bg-[#FDFDFD] dark:bg-[#303030] transition-all duration-300"
                                >
                                    <div
                                        className="w-1 h-16 bg-[#7D7D7D] rounded-sm absolute top-0 left-0"
                                    ></div>
                                    <div>
                                        <p
                                            className="font-rubik text-sm text-[#656575] pb-0.5 dark:text-[#B1B1B1]"
                                        >
                                            Aug 30
                                        </p>
                                        <h3
                                            className="font-rubik font-semibold text-base text-[#1A1919] dark:text-[#F5F5F5]"
                                        >
                                            SX<sup>2</sup> Survey
                                        </h3>
                                    </div>
                                    <div>
                                        <span
                                            className="text-[#656575] font-rubik bg-[#F8F7F1] rounded-sm text-xs py-1 px-2 dark:bg-[#121212] dark:text-[#B4B4B4] transition-all duration-300"
                                        >Due</span>
                                        <p><small className="text-[#00FF00]">{calculateDays("2023-08-30")} days left</small></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </main >
        </>
    )
}

export default GenericDashboard;